import React from 'react';
import { NavLink, Outlet, useNavigate, Link } from 'react-router-dom';
import { Package, MessageSquareQuote, LogOut, ExternalLink, Newspaper, Download, Inbox } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Logo from '../../components/Logo';

const linkClass = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-sm btn-transition ${
    isActive ? 'bg-[#0A2A63] text-white shadow' : 'text-slate-600 hover:bg-slate-100'
  }`;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => { logout(); navigate('/admin/login', { replace: true }); };

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col fixed inset-y-0 left-0">
        <div className="p-5 border-b border-slate-100">
          <Logo to="/admin" imgClassName="h-7" />
          <p className="mt-1 text-[10px] uppercase tracking-widest text-slate-400 font-bold">Admin Console</p>
        </div>
        <nav className="flex-1 p-4 space-y-2">
          <NavLink to="/admin" end className={linkClass} data-testid="admin-nav-products">
            <Package className="h-4 w-4" /> Products
          </NavLink>
          <NavLink to="/admin/testimonials" className={linkClass} data-testid="admin-nav-testimonials">
            <MessageSquareQuote className="h-4 w-4" /> Testimonials
          </NavLink>
          <NavLink to="/admin/blog" className={linkClass} data-testid="admin-nav-blog">
            <Newspaper className="h-4 w-4" /> Blog
          </NavLink>
          <NavLink to="/admin/leads" className={linkClass} data-testid="admin-nav-leads">
            <Download className="h-4 w-4" /> Blog leads
          </NavLink>
          <NavLink to="/admin/contacts" className={linkClass} data-testid="admin-nav-contacts">
            <Inbox className="h-4 w-4" /> Contacts
          </NavLink>
        </nav>
        <div className="p-4 border-t border-slate-100 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold text-slate-600 hover:bg-slate-100">
            <ExternalLink className="h-4 w-4" /> View site
          </Link>
          <button onClick={doLogout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold text-red-600 hover:bg-red-50" data-testid="admin-logout">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
          <p className="px-4 pt-2 text-[11px] text-slate-400 truncate">{user?.email}</p>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
